import { render, staticRenderFns } from "./FolderSettingsPublications.vue?vue&type=template&id=afa66f34"
import script from "./FolderSettingsPublications.vue?vue&type=script&lang=js"
export * from "./FolderSettingsPublications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports